import { render } from "./TreeViewCourses.vue?vue&type=template&id=c45281e8&scoped=true"
import script from "./TreeViewCourses.vue?vue&type=script&lang=js"
export * from "./TreeViewCourses.vue?vue&type=script&lang=js"

import "./TreeViewCourses.vue?vue&type=style&index=0&id=c45281e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45281e8"]])

export default __exports__